// extracted by mini-css-extract-plugin
export default {"moreList":"index_moreList_QWRXu","ulList":"index_ulList_HbkHA"};